import React, { useRef, useEffect } from 'react';
import { Field } from 'react-final-form';
import css from './NumericInput.module.css';

const MIN = 1;
const MAX = 99;
const DEBOUNCE_MS = 400;

const NumericInput = ({ name, step = 1, min = MIN, max = MAX, disabled, onChange }) => {
  const timeoutRef = useRef(null);
  const lastValueRef = useRef(null);

  useEffect(() => {
    return () => clearTimeout(timeoutRef.current);
  }, []);

  return (
    <Field name={name}>
      {({ input }) => {
        const value = Number(input.value) || min;

        const emitChange = v => {
          if (!onChange) return;

          lastValueRef.current = v;

          clearTimeout(timeoutRef.current);
          timeoutRef.current = setTimeout(() => {
            onChange(lastValueRef.current);
          }, DEBOUNCE_MS);
        };

        const setValue = v => {
          if (disabled) return;
          if (v < min || v > max) return;

          input.onChange(v);

          emitChange(v);
        };

        return (
          <div className={css.inputRoot}>
            <button
              type="button"
              onClick={() => setValue(value - step)}
              disabled={value <= min || disabled}
              className={css.button}
            >
              −
            </button>

            <input
              {...input}
              type="number"
              min={min}
              max={max}
              value={input.value ?? min}
              onChange={e => setValue(Number(e.target.value))}
              className={css.input}
              disabled={disabled}
            />

            <button
              type="button"
              onClick={() => setValue(value + step)}
              disabled={value >= max || disabled}
              className={css.button}
            >
              +
            </button>
          </div>
        );
      }}
    </Field>
  );
};

export default NumericInput;
